import { Common } from './common';
import * as Recording from './models/recording';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async update(
    segmentId: string,
    values: Partial<
      Pick<Recording.Segment, 'transcript' | 'inaudible' | 'needsReview'>
    >,
  ): Promise<Recording.Segment[]> {
    const url = this.common.constructPath(`/recording-segments/${segmentId}`);
    return this.common.patchJSON(url, values);
  }

  getFileURL(segmentId: string): string {
    return this.common.constructPath(`/recording-segments/${segmentId}/file`);
  }
}
